import { inject, ref, provide, InjectionKey, Ref, readonly } from 'vue';

export const breadcrumbsDataKey: InjectionKey<Ref<IBreadcrumb[]>> =
  Symbol('breadcrumbsData');

export default function () {
  const breadcrumbs: Ref<IBreadcrumb[]> = ref([]);

  provide(breadcrumbsDataKey, readonly(breadcrumbs));

  function setBreadcrumbs(breadcrumbsValue: IBreadcrumb[]) {
    breadcrumbs.value = breadcrumbsValue || [];
  }

  return { setBreadcrumbs };
}

export function getContext() {
  return {
    breadcrumbs: inject(breadcrumbsDataKey, ref<IBreadcrumb[]>([])),
  };
}

export function getBreadcrumbsCacheKey(pathName: string): string {
  return `breadcrumbs:${pathName}`;
}

export interface IBreadcrumb {
  url?: string;
  name: string;
}
